var Handlebars = require("../lib/handlebars.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"title",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + ">Request<div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"btn clear-request",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "><span "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"icon-clear",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "></span></div></div><ul "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"requests",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "></ul><div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"detail",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "></div>";
},"useData":true});